import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  CITemplateSelectedIds: [],
  CITemplateTreeData: [],
  CITemplateAppliedData: [],
  CITemplateSearchQuery: "",
  CITemplateExpandedItems: [],
};

const CITemplateTreeSlice = createSlice({
  name: "CITemplateTree",
  initialState,
  reducers: {
    setCITemplateSelectedIds: (state, action) => {
      state.CITemplateSelectedIds = action.payload;
    },
    setCITemplateTreeData: (state, action) => {
      state.CITemplateTreeData = action.payload;
    },
    setCITemplateAppliedData: (state, action) => {
      state.CITemplateAppliedData = action.payload;
    },
    setCITemplateSearchQuery: (state, action) => {
      state.CITemplateSearchQuery = action.payload;
    },
    resetCITemplateSelection: (state) => {
      state.CITemplateSelectedIds = [];
      state.CITemplateAppliedData = [];
    },
    setCITemplateExpandedItems: (state, action) => {
      state.CITemplateExpandedItems = action.payload;
    },
  },
});

export const {
  setCITemplateSelectedIds,
  setCITemplateTreeData,
  setCITemplateAppliedData,
  setCITemplateSearchQuery,
  resetCITemplateSelection,
  setCITemplateExpandedItems,
} = CITemplateTreeSlice.actions;

export default CITemplateTreeSlice.reducer;
